import {createContext, ReactNode, useState} from 'react';

// Define the shape of the context
interface TokenContextType {
  token?: string | null;
  setNewToken: (new_token: string, rememberMe?: boolean) => void;
  removeToken: () => void;
}

// Create the context.
export const TokenContext = createContext<TokenContextType | undefined>(
  undefined
);

const getStoredToken = (): string | null => {
  // Check localStorage first (rememberMe was checked), then sessionStorage
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

// Create a UserContextProvider component
export const TokenContextProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState(getStoredToken);

  const saveToken = (new_token: string, rememberMe = false) => {
    setToken(new_token);
    if (rememberMe) {
      localStorage.setItem('token', new_token);
      sessionStorage.removeItem('token');
    } else {
      sessionStorage.setItem('token', new_token);
      localStorage.removeItem('token');
    }
  };

  const deleteToken = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    setToken(null);
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        setNewToken: saveToken,
        removeToken: deleteToken
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

export default TokenContextProvider;
